/**
 * Created by Shreedhar Acharya
 * Created at 05/15/2019
 * https://marvelapp.com/43fgc52/screen/55854690
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import clone from 'ramda/src/clone';
import equals from 'ramda/src/equals';
import Accordion from '@components/@core/Accordion';
import Button from '@components/@core/AnimatedButton';
import Dropdown from '@components/@core/Dropdown';
import Filter from '@components/@core/Filter';
import Icon from '@components/@core/Icon';
import Input from '@components/@core/Input';
import Upload from '@components/@core/Upload';
import { DROP_FILE_TYPE } from '~/services/constants';

class Edit extends Component {
    state = {
        name: this.props.document.name || this.props.document.title,
        description: this.props.document.data.description,
        attachment: null,
        fileName: this.props.document.data?.file,
        selected: {
            author: [this.props.document.author_id],
            department: this.props.document.data.department,
            competency: this.props.document.data.competency,
            category: this.props.document.data.category,
        },
    };

    handleUpdate = () => {
        const { attachment, name, description, fileName, selected } = this.state;
        const payload = {
            document: {
                ...this.props.document,
                title: name,
                data: {
                    ...this.props.document.data,
                    category: selected.category,
                    competency: selected.competency,
                    department: selected.department,
                    description: description,
                    file: attachment ? fileName : this.props.document.data?.file,
                },
                author_id: selected.author,
            },
        };
        this.props.onUpdate(payload, attachment);
    };

    handleSelectTags = (key) => (tags) => {
        const selected = clone(this.state.selected);
        if (!equals(selected[key], tags)) {
            selected[key] = tags;
            this.setState({ selected });
        }
    };

    handleRemove = () => {
        this.setState({ attachment: null, fileName: null });
    };

    handleDrop = (e) => {
        this.setState({ attachment: e[0] });
        if (e[0]) this.setState({ fileName: e[0].name });
    };

    render() {
        const { name, description, fileName, selected } = this.state;
        const { type, document, authors, departments, competencies, categories, onChange } = this.props;

        const disabled =
            (name === document?.title &&
                description === document?.data?.description &&
                fileName === document?.data?.file &&
                selected.department === document?.data?.department &&
                selected.competency === document?.data?.competency &&
                selected.category === document?.data?.category) ||
            name === '' ||
            description === '' ||
            fileName === null;

        const dropdownMenu = [
            { id: 1, value: 'Assign' },
            { id: 3, value: 'Detail View' },
        ];

        return (
            <>
                <Filter back="all documents" />
                <div className="library-document-card border-5">
                    <div className="detail-content">
                        <div className="d-flex jc-between py-1">
                            <p className="dsl-b16 bold mb-0">Document Name</p>
                            <Dropdown align="right" data={dropdownMenu} caret="dots-without-title" returnBy="data" iconColor="#969faa" iconSize={16} onChange={onChange} />
                        </div>
                        <div className="py-2">
                            <Input direction="vertical" value={name} onChange={(e) => this.setState({ name: e })} />
                        </div>
                        <div className="py-2">
                            <Input title="Document Description" direction="vertical" value={description} onChange={(e) => this.setState({ description: e })} />
                        </div>
                        {type === 'esign' ? (
                            <Row className="mx-0 mt-2">
                                <Col xs={12} sm={6} className="px-0">
                                    <p className="dsl-m12 mb-0">Singers</p>
                                    <div className="p-2">
                                        <p className="dsl-b16 mb-0">15</p>
                                    </div>
                                </Col>
                                <Col xs={12} sm={6} className="px-0">
                                    <p className="dsl-m12 mb-0">Countersingers</p>
                                    <div className="p-2">
                                        <p className="dsl-b16 mb-0">3</p>
                                    </div>
                                </Col>
                            </Row>
                        ) : (
                            <Row className="mx-0 mt-2">
                                <Col xs={12} sm={6} className="px-0">
                                    <p className="dsl-m12 mb-0">File</p>
                                    <div className="p-2 word-break">
                                        {fileName ? (
                                            <>
                                                <a className="dsl-b16 text-primary" href={document.data.attachment} target="_blank">
                                                    {fileName}
                                                </a>
                                                <Button type="link" onClick={this.handleRemove}>
                                                    <Icon name="fas fa-trash-can" size={14} color="#376caf" />
                                                </Button>
                                            </>
                                        ) : (
                                            <Upload accept={DROP_FILE_TYPE[type]} title="UPLOAD FILE" icon="fas fa-file-import" color="#376caf" onDrop={this.handleDrop} />
                                        )}
                                    </div>
                                </Col>
                                <Col xs={12} sm={6} className="px-0">
                                    <p className="dsl-m12 mb-0">Last time Changed</p>
                                    <div className="p-2">
                                        <p className="dsl-b16 mb-0">{moment.utc(document.updated_at).local().format('MMM DD, YYYY')}</p>
                                    </div>
                                </Col>
                            </Row>
                        )}
                        <Accordion className="settings" icon={null}>
                            <Row className="mt-3">
                                <Col xs={12} sm={6} className="my-3">
                                    <Dropdown
                                        title="Author"
                                        direction="vertical"
                                        width="fit-content"
                                        data={authors}
                                        defaultIds={selected.author}
                                        getValue={(e) => e.name}
                                        onChange={this.handleSelectTags('author')}
                                    />
                                </Col>
                                <Col xs={12} sm={6} className="my-3">
                                    <Dropdown
                                        multi
                                        title="Departments"
                                        direction="vertical"
                                        width="fit-content"
                                        data={departments}
                                        defaultIds={selected.department}
                                        getValue={(e) => e.name}
                                        onChange={this.handleSelectTags('department')}
                                    />
                                </Col>
                                <Col xs={12} sm={6} className="my-3">
                                    <Dropdown
                                        multi
                                        title="Competencies"
                                        direction="vertical"
                                        width="fit-content"
                                        data={competencies}
                                        defaultIds={selected.competency}
                                        getValue={(e) => e.name}
                                        onChange={this.handleSelectTags('competency')}
                                    />
                                </Col>
                                <Col xs={12} sm={6} className="my-3">
                                    <Dropdown
                                        multi
                                        title="Categories"
                                        direction="vertical"
                                        width="fit-content"
                                        data={categories}
                                        defaultIds={selected.category}
                                        getValue={(e) => e.name}
                                        onChange={this.handleSelectTags('category')}
                                    />
                                </Col>
                            </Row>
                        </Accordion>
                        <div className="mt-3 text-end">
                            <Button name="Save Document" disabled={disabled} onClick={this.handleUpdate} />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

Edit.propTypes = {
    document: PropTypes.any.isRequired,
};

Edit.defaultProps = {
    document: {},
};

export default Edit;
